import React, { useState, useRef, useEffect, Fragment } from "react";
import { Link } from "react-router-dom";
import PageTitle from "../../../layouts/PageTitle";
import WheelChair from "../../../../images/avatar/Wheelchair.png";
import PaginationButtons from "../../../Custom/Pagination";
import { post } from "../../../Helper/api_helper";
import {
  POST_PackageList,
  POST_PackageUpdateActiveInactive,
  POST_PackageDelete,
} from "../../../Helper/url_helper";
import swal from "sweetalert";
import { t } from "i18next";
import { Spin } from "antd";
const PackageList = () => {
  const [recordCount, setRecordCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentSizePerPage, setCurrentSizePerPage] = useState(10);
  const [packageList, setPackageList] = useState([]);

  const [search, setSearch] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  var objLogin = JSON.parse(localStorage.getItem("userDetails"));

  const handleOnChangeSearch = (e) => {
    setSearch(e.target.value);
  };

  useEffect(() => {
    getData();
  }, [search]);

  const getData = async (page = 1, sizePerPage = 10) => {
    setIsLoading(true);
    let response = await post(POST_PackageList, {
      CurrentPage: page,
      PageSize: sizePerPage,
      Search: search,
      Sorting: "",
    });
    setIsLoading(false);
    setRecordCount(response.TotalRecordCount);
    setPackageList(response.PackageList);
    //setCurrentPage(page);
    setCurrentSizePerPage(sizePerPage);
    if (page > 1 && response?.PackageList?.length === 0) {
      setCurrentPage(page - 1);
      getData(page - 1);
    } else {
      setCurrentPage(page);
    }
  };

  const delete_Package = (pID) => {
    swal({
      title: "Are you sure you want to delete the package?",
      text: "You won't be able to revert this!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((confirmDelete) => {
      if (confirmDelete) {
        delete_PackageConfirm(pID);
      }
    });
  };

  const delete_PackageConfirm = async (pID) => {
    setIsLoading(true);
    let response = await post(POST_PackageDelete, {
      EncryptPackageID: pID,
      EncryptModifiedBy: objLogin.LoginIDEncrypt,
    });
    if (response.IsSuccess) {
      swal({
        title: "Deleted",
        text: "Record has been deleted.",
        icon: "success",
        button: "OK",
      });
      getData(currentPage, currentSizePerPage);
    } else {
      swal("Error!", t(response.MessageCode), "error");
    }
    setIsLoading(false);
  };

  const ActiveInactive_Package = async (pID, pStatus) => {
    swal({
      title: `Are you sure you want to ${
        pStatus ? "inactive" : "active"
      } the package?`,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((confirmStatus) => {
      if (confirmStatus) {
        ActiveInactive_PackageConfirm(pID, pStatus);
      }
    });
  };

  const ActiveInactive_PackageConfirm = async (pID, pStatus) => {
    setIsLoading(true);
    let response = await post(POST_PackageUpdateActiveInactive, {
      EncryptPackageID: pID,
      IsActive: !pStatus,
      EncryptModifiedBy: objLogin.LoginIDEncrypt,
    });
    if (response.IsSuccess) {
      swal({
        title: pStatus ? "Inactivated" : "Activated",
        text: pStatus
          ? "Record has been Inactivated."
          : "Record has been Activated.",
        icon: "success",
        button: "OK",
      });
      getData(currentPage, currentSizePerPage);
    } else {
      swal("Error!", t(response.MessageCode), "error");
    }
    setIsLoading(false);
  };
  return (
    <>
      <Fragment>
        <Spin size="large" spinning={isLoading} tip={"Loading..."}>
          <PageTitle motherMenu="Master" activeMenu="Packages" />

          <div className="form-head d-flex mb-3 mb-md-4 align-items-start">
            <div className="mr-auto d-none d-lg-block">
              <Link
                to="/add-package"
                className="btn-xs btn btn-primary btn-rounded"
              >
                + Add Package
              </Link>
            </div>
            <div className="input-group search-area ml-auto d-inline-flex mr-3">
              <input
                type="text"
                className="form-control"
                placeholder="Search here"
                value={search}
                onChange={handleOnChangeSearch}
              />
              <div className="input-group-append">
                <button type="button" className="input-group-text">
                  <i className="flaticon-381-search-2" />
                </button>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-12">
              <div className="table-responsive">
                <div id="patient_list" className="dataTables_wrapper no-footer">
                  <table
                    id="example5"
                    className="table table-striped patient-list mb-4 dataTablesCard fs-14 dataTable no-footer"
                    role="grid"
                    aria-describedby="example5_info"
                  >
                    <thead>
                      <tr role="row">
                        <th
                          className="sorting"
                          tabIndex={0}
                          aria-controls="example5"
                          rowSpan={1}
                          colSpan={1}
                          aria-label="Staff No.: activate to sort column ascending"
                          style={{ width: "60%" }}
                        >
                          Package Name
                        </th>
                        <th
                          className="sorting"
                          tabIndex={0}
                          aria-controls="example5"
                          rowSpan={1}
                          colSpan={1}
                          aria-label="Staff Name: activate to sort column ascending"
                          style={{ width: "30%", textAlign: "center" }}
                        >
                          Package Duration
                        </th>

                        <th
                          className="sorting"
                          tabIndex={0}
                          aria-controls="example5"
                          rowSpan={1}
                          colSpan={1}
                          aria-label="Actions: activate to sort column ascending"
                          style={{ width: "10%" }}
                        >
                          Actions
                        </th>
                      </tr>
                    </thead>
                    {recordCount > 0 ? (
                      <tbody>
                        {packageList?.map((element, i) => (
                          <tr role="row" className="odd">
                            <td>{element.PackageName}</td>
                            <td style={{ textAlign: "center" }}>
                              {element.PackageDurationInDays}
                            </td>
                            <td>
                              <div className="d-flex">
                                <Link
                                  to={`/edit-package/${window.btoa(
                                    element.PackageIDEncrypted
                                  )}`}
                                  className="btn btn-light shadow btn-xs sharp mr-1"
                                  title="Edit"
                                >
                                  <i className="fa fa-pencil"></i>
                                </Link>
                                <Link
                                  to="#"
                                  className="btn btn-light shadow btn-xs sharp mr-1 rounded-circle"
                                  title={
                                    element.IsActive ? "Active" : "Inactive"
                                  }
                                  onClick={() => {
                                    ActiveInactive_Package(
                                      element.PackageIDEncrypted,
                                      element.IsActive
                                    );
                                  }}
                                >
                                  <i
                                    className="fa fa-circle mt-1"
                                    style={{
                                      color: element.IsActive ? "green" : "red",
                                    }}
                                  ></i>
                                </Link>
                                <Link
                                  to="#"
                                  className="btn btn-light shadow btn-xs sharp"
                                  title="Delete"
                                  onClick={() => {
                                    delete_Package(element.PackageIDEncrypted);
                                  }}
                                >
                                  <i
                                    className="fa fa-trash"
                                    style={{ color: "red" }}
                                  ></i>
                                </Link>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    ) : (
                      <div className="mt-3 ml-3">{"No Record Found"}</div>
                    )}
                  </table>
                  <div className="d-sm-flex text-center justify-content-between align-items-center">
                    <div
                      className="dataTables_info"
                      id="example5_info"
                      role="status"
                      aria-live="polite"
                    >
                      Showing{" "}
                      {recordCount > 0
                        ? (currentPage - 1) * currentSizePerPage + 1
                        : 0}{" "}
                      to{" "}
                      {recordCount > currentPage * currentSizePerPage
                        ? currentPage * currentSizePerPage
                        : recordCount}{" "}
                      of {recordCount} entries
                    </div>
                    <div className="paging_simple_numbers d-flex  justify-content-center align-items-center">
                      <PaginationButtons
                        totalPages={recordCount / currentSizePerPage}
                        currentPage={currentPage}
                        getData={getData}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Spin>
      </Fragment>
    </>
  );
};

export default PackageList;
